import { HttpClient } from '@angular/common/http';
import { User } from 'app/shared/models';
import { environment } from '@env';
import { map, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Invitation } from '@shared/models/invitation.model';

@Injectable({
    providedIn: 'root',
})
export class UserService {

    constructor(private http: HttpClient) { }

    /**
     * Retrieves user details for a given user ID
     * @param {number} userId - The {@link id} of the user
     * @return {Observable<User>} - The user data
     */
    getUser(userId: number): Observable<User> {
        return this.http.get<User>(environment.endpoints.user(userId))
            .pipe(map(user => new User().deserialize(user)));
    }

    /**
     * Updates user details for a given user ID and user
     * @param {number} userId - The {@link id} of the user
     * @param {User} updatedUser - The updated user
     * @return {Observable<User>} - The user data
     */
    updateUser(userId: number, updatedUser: User): Observable<User> {
        let formData = new FormData();
        Object.entries(updatedUser.serialize()).forEach(([key, value]: any) => {
            if (value != null) {
                if (key == 'avatar'){
                    let file = value as File;
                    formData.append(key, file);
                } else {
                    formData.append(key, value.toString());
                }
            }
        });
        return this.http.patch<User>(environment.endpoints.user(userId), formData)
            .pipe(map(user => new User().deserialize(user)));
    }
}